import { render, staticRenderFns } from "./StockIndex.vue?vue&type=template&id=1bbc03fa"
import script from "./StockIndex.vue?vue&type=script&lang=js"
export * from "./StockIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports